import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DesktopAppPageComponent } from './desktopAppPage.component';
import { SharedModule } from 'app/shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';

const routes = [
  { path: 'desktopApp', component: DesktopAppPageComponent }
];

@NgModule({
  declarations: [DesktopAppPageComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    RouterModule.forChild(routes)
  ]
})
export class DesktopAppPageModule { }
